import React from "react";
import PropTypes from "prop-types";
import {
  CardBox,
  CardTitle,
  Centered,
  InformationText,
  SplitPanel
} from "../CardsStyled";
import { useTranslate } from "hooks/translation-hooks";
import IconDispatcher from "components/Icons/IconDispatcher";

const contractorOnHisWayCategory = "contractor_on_the_way";

export const ContractorOnHisWay = ({
  isCurrent,
  providerName,
  providerType
}) => {
  const t = useTranslate();
  return (
    <CardBox data-category={contractorOnHisWayCategory}>
      <SplitPanel>
        <Centered>
          <IconDispatcher type={providerType} />
        </Centered>
        <Centered>
          <CardTitle>{t("contractor_on_his_way_card-title")}</CardTitle>
        </Centered>
        <InformationText>
          {`${t("contractor_on_his_way_card-text_1")} ${providerName} ${t(
            "contractor_on_his_way_card-text_2"
          )}`}
        </InformationText>
      </SplitPanel>
    </CardBox>
  );
};

ContractorOnHisWay.propTypes = {
  providerName: PropTypes.string.isRequired,
  providerType: PropTypes.string,
  isCurrent: PropTypes.bool
};

ContractorOnHisWay.defaultProps = {
  isCurrent: false
};

export default ContractorOnHisWay;
